import { type ReactNode, useState } from 'react';
import { cn } from '@/utils/cn';

const SIZES = {
  xxs: 'h-4 w-4 text-[8px]',
  xs: 'h-[22px] w-[22px] text-[10px]',
  sm: 'h-6 w-6 text-xs',
  md: 'h-8 w-8 text-sm',
  lg: 'h-10 w-10 text-base',
  xl: 'h-12 w-12 text-lg',
};

type AvatarProps = {
  src?: string | undefined;
  name: string;
  size?: 'xxs' | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined;
};

function Initials({ name, size = 'md' }: AvatarProps): ReactNode {
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-full bg-surface-secondary font-medium text-text-secondary',
        SIZES[size]
      )}
    >
      {name.slice(0, 2).toUpperCase()}
    </div>
  );
}

export function Avatar({ src, name, size = 'md' }: AvatarProps): ReactNode {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    return <Initials name={name} size={size} />;
  }

  return (
    <img
      src={src}
      alt={name}
      className={cn('rounded-full object-cover', SIZES[size])}
      onError={() => setFailed(true)}
    />
  );
}
